module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "remove-icon.d37016c7.svg";